import React from "react";
import { Routes, Route } from "react-router-dom";
import NotFound from "../internal/components/404page";
// import { AJWWDataEmailPage } from "./ajww/AJWWEmailDataPage";

const InternalRoutes: React.FC = () => {
  return (
    <Routes>
      {/* AJWW Routes */}
      {/* <Route
        path="ajww/rates/all"
        element={<AJWWDataEmailPage page="rates" />}
      /> */}

      {/* AJWW Quotes */}
      {/* <Route
        path="ajww/quotes/all"
        element={<AJWWDataEmailPage page="quotes" />}
      /> */}

      {/* AJWW analytics */}
      {/* <Route
        path="ajww/analytics"
        element={<AJWWDataEmailPage page="analytics" />}
      /> */}

      {/* Catch-all for Internal 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default InternalRoutes;
